import { render, staticRenderFns } from "./DiscountInfo.vue?vue&type=template&id=df8037b0&scoped=true"
import script from "./DiscountInfo.vue?vue&type=script&lang=ts"
export * from "./DiscountInfo.vue?vue&type=script&lang=ts"
import style0 from "./DiscountInfo.vue?vue&type=style&index=0&id=df8037b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8037b0",
  null
  
)

export default component.exports